import { gql } from 'apollo-boost'

const UPDATE_SCRAPING_TEST_CASE_TAGS = gql`
  mutation updateScrapingTestCaseTags(
    $id: ID!
    $newTagIds: [ID]!
    $removedTagIds: [ID]!
  ) {
    updateScrapingTestCaseTags(
      id: $id
      newTagIds: $newTagIds
      removedTagIds: $removedTagIds
    ) {
      id
      menuId
    }
  }
`

export default UPDATE_SCRAPING_TEST_CASE_TAGS
